export function createFlashcardsTursoWorker(name: string): Worker {
  return new Worker(new URL('./flashcards-turso-worker.ts', import.meta.url), { type: 'module', name })
}
